/*
 * FileDownload Messages
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.FileDownload';

export default defineMessages({
  preparing: {
    id: `${scope}.preparing`,
    defaultMessage: 'Your download should start automatically…',
  },
  manualLink: {
    id: `${scope}.manualLink`,
    defaultMessage: "If it doesn't, click here to download the file.",
  },
  invalidLink: {
    id: `${scope}.invalidLink`,
    defaultMessage:
      'This download link is no longer valid. It may have already been used or expired — please request a new export.',
  },
});
